/**
 * Danish krone.
 */
export var DKK = {
  code: 'DKK',
  base: 10,
  exponent: 2
};